import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as stepperComponents from '~/components/stepper';

import { SaveAfiliation, NotAffiliationFinalized } from '~/components/modals';
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        data: Array
    },
    layout: 'stepped',
    components: _extends({}, stepperComponents, {
        SaveAfiliation: SaveAfiliation,
        NotAffiliationFinalized: NotAffiliationFinalized
    }),
    data: function data() {
        return {
            itemHeight: 30,
            height: 400,
            page: 1,
            pageSize: 50,
            loading: false,
            steps: this.step
        };
    },

    computed: {
        isMovil: function isMovil() {
            return this.$vuetify.breakpoint.name == 'md' || this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/ranking-mobile-table.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/ranking-mobile-table.vue
// module chunks = 0 1